import React, { useState, useEffect, useMemo, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  MenuItem,
  Tooltip,
  TextField,
  FormControlLabel
} from '@material-ui/core';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es'

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import { useTable, useExpanded } from "react-table";

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import '../../styles/style.scss';
import '../../styles/saleOrderStyle.scss';

import SaleOrderService from "../../services/saleOrder.service";

import { convertDateToJulian } from '../../constants/component/convertDateToJulian';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import usersService from '../../services/users.service';
import { CustomCheckbox } from '../../constants/customComponent/CustomCheckbox';
import { compareAsc, format, parse } from 'date-fns';


export const SaleOrderScreen = () => {

  const { isLoggedIn, user } = useSelector(state => state.auth);
  const an8Logged = isLoggedIn ? user.noCustomer : '---';

  const dateMin = new Date();

  const [selectStartDate, handleStartDateChange] = useState(null);
  const [selectEndDate, handleEndDateChange] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const [statusCheckClients, setStatusCheckClients] = useState(false);

  const [customers, setCustomers] = useState({
    isLoading: true,
    isDisabled: true,
    data: []
  });

  const [contentCompany, setContentCompany] = useState([{
    isLoading: false,
    isDisabled: true,
    data: ['']
  }]);

  const [saleOrder, setSaleOrder] = useState([]);
  const saleOrderRef = useRef();

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isSubmitingData, setIsSubmitingData] = useState(false);
  const [isDownloadFile, setIsDownloadFile] = useState(false);

  const [errorResponse, setErrorResponse] = useState('');
  const [isErrorResponse, setIsErrorResponse] = useState(false);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false)
  saleOrderRef.current = saleOrder;

  const validationSchema = Yup.object().shape({
    startDate: Yup.date().default(selectStartDate).required('valor requerido'),
    endDate: Yup.date().default(selectEndDate).required('valor requerido')
      .min(selectStartDate ? selectStartDate : dateMin)
  });

  const {
    register,
    control,
    handleSubmit,
    getValues
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    // let dateSubtract = new Date();
    // dateSubtract.setMonth(dateSubtract.getMonth() - 4);

    // const dateMinDefaultOrder = dateSubtract;
    const dateMinDefaultOrder = new Date();
    const dateMaxDefaultOrder = new Date();

    handleStartDateChange(dateMinDefaultOrder);
    handleEndDateChange(dateMaxDefaultOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const getCustomers = () => {

    setCustomers({
      isLoading: true,
      isDisabled: true,
      data: []
    })
    usersService.getCustomerAssociatesByAN8(an8Logged).then((response) => {
      let customersResponse = response;

      setCustomers({
        isLoading: false,
        isDisabled: false,
        data: customersResponse
      });
    }).catch((error) => {
      console.log(error);
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data: ['']
      });

      if (sessionDifference > Number(tokenExpired)) {
        sesionExpired(dispatch, history);
      } else {
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

  const getCompany = (an8) => {
    setContentCompany({
      isLoading: true,
      isDisabled: true,
      data: []
    })
    SaleOrderService.getCompany(an8).then((response) => {
      setContentCompany({
        isLoading: false,
        isDisabled: false,
        data: response
      })
    }).catch((error) => {
      setContentCompany({
        isLoading: false,
        isDisabled: false,
        data: ['']
      })
      if (sessionDifference > Number(tokenExpired)) {
        sesionExpired(dispatch, history);
      } else {
        actionErrorConnection(error, 'Error al recuperar planta');
      }
    });
  }

  /** 
   * Recupera lista de plantas
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   * 
  */
  const onCustomerChange = () => {
    const params = getValues();
    if (params.an8 && params.an8 !== '') getCompany(params.an8);
  }

  /**
   * Cambia el estado del swich para buscar por todos los clientes
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   */
  const handleChangeStatusCheckClients = () =>{
    setStatusCheckClients(!statusCheckClients);
  }

  const onSubmit = (data, maxDate, minDate) => {

    const element = document.getElementById('collapseExample');
    element.classList.remove('show');

    setSaleOrder([]);
    setIsLoadingData(true);
    setIsErrorResponse(false);
    setIsSubmitingData(true);

    const params = getValues();

      if (!data) {
        params.startDate = convertDateToJulian(minDate);
        params.endDate = convertDateToJulian(maxDate);
      } else {
        params.startDate = convertDateToJulian(data.startDate);
        params.endDate = convertDateToJulian(data.endDate);
      }

    const dataFilter = {
      ...params,
    userAll: statusCheckClients
  };
    
    getSaleOrderByFilterService(dataFilter);

  };
  const getSaleOrderByFilterService = (dataFilter) => {
    SaleOrderService.getAllSaleOrderByFilters(dataFilter, an8Logged)
      .then((response) => {
        setIsErrorResponse(false);
        setIsLoadingData(false);
        setIsSubmitingData(true);
        let { orderTracking } = response;
        orderTracking.sort((a,b)=>{
          const dateA = parse(a.requestedDate, 'dd/MM/yyyy', new Date());
          const dateB = parse(b.requestedDate, 'dd/MM/yyyy', new Date());

          const dateComparison = compareAsc(dateA, dateB);
          if (dateComparison !== 0) return dateComparison;

          // PREVIO
          // if (a.prog_comp === "Programa" && b.prog_comp === "Complemento") return -1;
          // if (a.prog_comp === "Complemento" && b.prog_comp === "Programa") return 1;
          if(a.salesOrderNumber > b.salesOrderNumber) return 1
          if(a.salesOrderNumber < b.salesOrderNumber) return -1

          return 0; 
        })
        setSaleOrder(orderTracking);
      })
      .catch((error) => {
        setIsSubmitingData(true);
        setIsLoadingData(false);
        if (error.response) {
          setErrorResponse(error.response.data.mensaje);
          if (sessionDifference > Number(tokenExpired)) {
            sesionExpired(dispatch, history);
          }
        } else {
          setErrorResponse(error);
        }
        setIsErrorResponse(true);
        actionErrorConnection(error, 'Error al recuperar información.');
      });

  }

  /**
   * Prepara la descarga del archivo
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   */
  const downloadFile = () =>{

  setIsDownloadFile(true);
    const params = getValues();
    const dataToSend = {
      an8:params.an8,
      company: params.company,
      startDate:convertDateToJulian(selectStartDate),
      endDate: convertDateToJulian(selectEndDate)
    }
            
    const fileName = `seguimiento_ordenes_venta_${dataToSend.an8}_${selectStartDate.toLocaleDateString()}-${selectEndDate.toLocaleDateString()}`
    if(checkBoxStatus){
      getDownloadAllXls(fileName)
    }else{

      getDownloadXls(fileName);
    }
  };
const getDownloadAllXls = ()=>{
 const params = getValues();
 const dataToSend = {
  user:params.an8,
  plant: params.company,
  startDate:convertDateToJulian(selectStartDate),
  endDate: convertDateToJulian(selectEndDate),
  invoiced:params.invoice
}
  const startDate = format(selectStartDate, "MM/dd/yyyy")
  const endDate = format(selectEndDate, "MM/dd/yyyy")
  const fileName = `${dataToSend.user}-${startDate}-${endDate}.xls`
  SaleOrderService.downloadAllSalesOrderAn8(dataToSend,user.noCustomer).then(
    (response)=>{
      const byteString = window.atob(response.split(',')[1]);
      const mimeString = response.split(',')[0].split(':')[1].split(';')[0];

      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      const dataBlob = new Blob([ab], { type: mimeString });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        setIsDownloadFile(false);
        return
      }
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setIsDownloadFile(false);
    },
    (error)=>{
      setIsDownloadFile(false);
      actionErrorConnection(error, 'Error al descargar archivo xls.');
    });
  console.log('descargar archivo xls');
  
}

/**
   * Prepara la descarga del archivo
   * @param {string} fileName - nombre del archivo a descargar
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   */
  const getDownloadXls = ( fileName) => {
    SaleOrderService.downloadSaleOrderDetailXlsx(saleOrder, getValues().an8).then(
      (response)=>{
        console.log('ok descarga');
        console.log("descarga", response)
        const byteString = window.atob(response.split(',')[1]);
        const mimeString = response.split(',')[0].split(':')[1].split(';')[0];

        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }

        const dataBlob = new Blob([ab], { type: mimeString });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
          setIsDownloadFile(false);
          return
        }

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url
        link.setAttribute('download', `${fileName}.xls`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        setIsDownloadFile(false);
      },
      (error)=>{
        setCheckBoxStatus(false)
        setIsDownloadFile(false);
        actionErrorConnection(error, 'Error al descargar archivo xls.');
      });
    console.log('descargar archivo xls');
    
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Cliente',
        accessor: 'an8'
      },
      {
        Header: "Fecha solicitada",
        accessor: "requestedDate",
      },
      {
        Header: "T. Orden Venta",
        accessor: "orderSale",
        maxWidth: 180,
        minWidth: 180,
        width: 180
      },
      {
        Header: "Num. Orden Venta",
        accessor: "salesOrderNumber",
        maxWidth: 180,
        minWidth: 180,
        width: 180
      },
      {
        Header: "O. Venta",
        accessor: "sale",
        maxWidth: 180,
        minWidth: 180,
        width: 180
      },
      {
        Header: "Planta",
        accessor: "plant",
      },
      {
        Header: "T. cemento",
        accessor: "cement",
      },
      {
        Header: "TN",
        accessor: "tn",
      },
      {
        Header: "Estado",
        accessor: "status",
        maxWidth: 180,
        minWidth: 180,
        width: 180
      },
      {
        Header: "Remisión",
        accessor: "remission",
      },
      {
        Header: 'Factura',
        accessor: 'numberTypeInvoice'
      },
      {
        Header: "Prog / Comp",
        accessor: "prog_comp",
      },
      {
        Header: "Bloq.",
        accessor: "blocking",
      },
      {
        Header: "Fecha / Hora",
        accessor: "date_hour",
      }
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: saleOrder,
  },
    useExpanded);

  console.log("this is rows", rows)
  return (
    <>
      <div className="container-fluid p-0 m-0">
        <div className="row flex-nowrap p-0 m-0">
          <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
            <SidebarMenu />
          </div>
          <div className="col p-0 ms-1 me-1">
            <NavTopMenu />
            <div className="container ps-3 pe-3 container-size">
              <div className="row base-container ">
                <div>
                  <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                    <span className="h4">Seguimiento órdenes de venta</span>
                  </div>
                  <div className="col-12 pt-3 pb-3 ps-1 pe-1">
                    <div className="row ">
                      <div className="col-12 ">
                        <div className="w-100 d-flex justify-content-end">

                          {(customers.isLoading || contentCompany.isLoading) &&
                            <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                              <div className="custom-icon-loading me-1">
                                <i className="fas fa-spinner fa-spin"></i>
                              </div>
                            </Tooltip>
                          }
                          <Tooltip title="Filtrar" placement="top-start" arrow>
                            <button className="btn custom-btn-icons"
                              type="button" data-bs-toggle="collapse"
                              data-bs-target="#collapseExample" aria-expanded="false"
                              aria-controls="collapseExample">
                              <i className="fas fa-filter"></i>
                            </button>
                          </Tooltip>
                          {
                            isDownloadFile ?
                            <Tooltip title="Descargando..." placement="top-start" arrow>
                              <div className="custom-icon-loading me-1">
                                <i className="fas fa-spinner fa-spin"></i>
                              </div>
                            </Tooltip>
                            :
                            <Tooltip title="Descargar resultados" placement="top-start" arrow>
                              <div>
                                <button 
                                  className="btn custom-btn-icons" 
                                  onClick={()=>downloadFile()}
                                  type="button"
                                  disabled={ checkBoxStatus ?  isLoadingData || isErrorResponse : isLoadingData || isErrorResponse || !isSubmitingData   }
                                >
                                  <i className="fas fa-download"></i>
                                </button>
                              </div>
                            </Tooltip>
                          }
                          <FormControlLabel
                              control={
                                <CustomCheckbox
                                  onChange={() => setCheckBoxStatus((prev)=>!prev)}
                                  checked={checkBoxStatus}
                                  disabled={isLoadingData || isErrorResponse || customers.isLoading || !customers.data.length }
                                />
                              }
                              label={'Descargar Todos'}
                            />
                        </div>
                        <div className="collapse show" id="collapseExample">
                          <div className="filter-continer">
                            <div className="container mt-3">
                              <form className="row">
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <TextField
                                    select
                                    id="an8"
                                    name="an8"
                                    label="Num. cliente*"
                                    variant="outlined"
                                    size="small"
                                    disabled={customers.isDisabled || customers.isLoading}
                                    fullWidth
                                    defaultValue={''}
                                    {...register('an8')}
                                    onBlur={onCustomerChange}
                                  >
                                    <MenuItem value="">Seleccionar cliente</MenuItem>
                                    {customers.data.map(({ noCustomer, name }) => (
                                      <MenuItem key={noCustomer} value={noCustomer}>
                                        {noCustomer} - {name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <MuiPickersUtilsProvider
                                    utils={DateFnsUtils}
                                    locale={esLocale}>
                                    <DatePicker
                                      disableToolbar
                                      autoOk
                                      fullWidth
                                      required
                                      control={control}
                                      id="startDate"
                                      name="startDate"
                                      inputVariant="outlined"
                                      variant="inline"
                                      label="Fecha de inicio"
                                      size="small"
                                      format="dd/LLLL/yyyy"
                                      value={selectStartDate}
                                      onChange={handleStartDateChange}
                                    />
                                  </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <MuiPickersUtilsProvider
                                    utils={DateFnsUtils}
                                    locale={esLocale}>
                                    <DatePicker
                                      disableToolbar
                                      autoOk
                                      fullWidth
                                      required
                                      control={control}
                                      id="endDate"
                                      name="endDate"
                                      inputVariant="outlined"
                                      variant="inline"
                                      label="Fecha de Fin"
                                      size="small"
                                      format="dd/LLLL/yyyy"
                                      minDate={selectStartDate}
                                      // maxDate={dateMax}
                                      minDateMessage="La fecha debe ser mayor a la de inicio"
                                      value={selectEndDate}
                                      onChange={handleEndDateChange}
                                    />
                                  </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <TextField
                                    select
                                    id="company"
                                    name="company"
                                    label="Planta"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    defaultValue={''}
                                    disabled={contentCompany.isDisabled || contentCompany.isLoading}
                                    {...register('company')}
                                  >
                                    <MenuItem value="">Seleccionar planta</MenuItem>
                                    {contentCompany.data?.map((option) => (
                                      <MenuItem key={option} value={option}>
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <TextField
                                    select
                                    id="factura"
                                    name="invoice"
                                    label="Facturas"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    defaultValue={''}
                                    disabled={contentCompany.isDisabled || contentCompany.isLoading}
                                    {...register('invoice')}
                                  >
                                      <MenuItem  value="">
                                        Seleccionar
                                      </MenuItem>
                                      <MenuItem  value={true}>
                                        Facturados
                                      </MenuItem>
                                      <MenuItem  value={false}>
                                        No Facturados
                                      </MenuItem>
                                      <MenuItem  value={"all"}>
                                        Todos
                                      </MenuItem>
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3 d-none">
                                <FormControlLabel
                                      control={
                                        <CustomCheckbox
                                          onChange={() => handleChangeStatusCheckClients()}
                                          checked={statusCheckClients}
                                        />
                                      }
                                      label={
                                        <span className="checkbox-text">Seleccionar todos los clientes</span>
                                      }
                                    />
                                </div>
                                <div className="col-12 w-100 d-flex justify-content-end">
                                  <Tooltip title={(!selectStartDate || !selectEndDate) ? "Completar filtros obligatorios" : "Buscar"} placement="top-start" arrow>
                                    <div>
                                      <button
                                        className="ms-2 mb-3 btn custom-btn"
                                        disabled={isLoadingData || !selectStartDate || !selectEndDate}
                                        onClick={handleSubmit(onSubmit)}
                                        type='submit'
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseExample"
                                        aria-expanded="false"
                                        aria-controls="collapseExample"
                                      >
                                        <i className="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </Tooltip>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="w-100 d-flex justify-content-end">

                        </div>

                        <div className='table-wrap'>
                          <table
                            className="table-order"
                            {...getTableProps()}
                          >
                            <thead>
                              {headerGroups.map((headerGroup, i) => (
                                <tr {...headerGroup.getHeaderGroupProps()} className="border-content sticky-header" key={i}>
                                  {headerGroup.headers.map((column, j) => (
                                    <th {...column.getHeaderProps()}
                                      className="border-element header-element header-text pt-3 pb-3" key={j}>
                                      {column.render("Header")}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <React.Fragment key={row.getRowProps().key}>
                                    <tr className="element-row border-content">
                                      {row.cells.map((cell, i) => {
                                        return (
                                          <td className="border-element content-text pt-2 pb-2"
                                            {...cell.getCellProps()}
                                            key={i}>
                                            {
                                              cell.column.id === 'an8' ?
                                                getValues().an8
                                                : cell.render("Cell")
                                            }
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                          {(isErrorResponse) &&
                            <div className="error-message border-content pt-4 pb-4">
                              <span className="">Error: {errorResponse && errorResponse.toString()}</span>
                            </div>}
                          {(isLoadingData) &&
                            <div className="border-content pt-4 pb-4 custom-icon-loading">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>}
                          {(saleOrder.length === 0 && !isLoadingData && !isErrorResponse && isSubmitingData) &&
                            <div className="element-row-message border-content pt-4 pb-4 ">
                              <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                            </div>}
                          {
                            (!isSubmitingData && !isLoadingData && !isErrorResponse) &&
                            <div className="element-row-message border-content pt-4 pb-4">
                              <span>Ejecute una búsqueda para obtener resultados.</span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

SaleOrderScreen.propTypes = {
  row: PropTypes.any,
  getToggleAllRowsSelectedProps: PropTypes.any
};